export const GET_MEETING_INFO_START = 'GET_MEETING_INFO_START'
export const GET_MEETING_INFO_END = 'GET_MEETING_INFO_END'
export const SHOW_MEETING_LOADER = 'SHOW_MEETING_LOADER'
export const HIDE_MEETING_LOADER = 'HIDE_MEETING_LOADER'
